import React, { ReactNode } from 'react';
import { Button, ModalBody, ModalFooter, ModalHeader, ModalProps, Modal as RSModal } from 'reactstrap';

interface ComponentProps extends ModalProps {
  className?: string;
  headerClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
  header?: ReactNode;
  isOpen?: boolean;
  footer?: ReactNode;
  setIsOpen: (toggle: boolean) => void;
  includeFooter?: boolean;
  closeButtonText?: string;
  // When true, removes every close affordance (header X and the default footer close button) — e.g. while a
  // long-running operation must not be interrupted. The caller controls when it flips.
  disableClose?: boolean;
}

const Modal: React.FC<ComponentProps> = ({
  isOpen,
  setIsOpen,
  children,
  header,
  bodyClassName,
  headerClassName,
  footerClassName,
  footer,
  closeButtonText = 'Close',
  includeFooter = true,
  disableClose = false,
  ...props
}) => {
  return (
    <RSModal isOpen={isOpen} {...props}>
      {header && (
        <ModalHeader
          className={headerClassName ?? 'header'}
          // Omitting `toggle` makes reactstrap render no close (X) button.
          toggle={
            disableClose
              ? undefined
              : () => {
                  setIsOpen(!isOpen);
                }
          }
        >
          {header}
        </ModalHeader>
      )}
      <ModalBody className={bodyClassName}>{children}</ModalBody>
      {includeFooter && (
        <ModalFooter className={footerClassName}>
          {footer ? (
            footer
          ) : (
            !disableClose && (
              <Button color="secondary" onClick={() => setIsOpen(!isOpen)}>
                {closeButtonText}
              </Button>
            )
          )}
        </ModalFooter>
      )}
    </RSModal>
  );
};

export default Modal;
